import { render, staticRenderFns } from "./OptionFormDialog.vue?vue&type=template&id=0a8a8288&"
import script from "./OptionFormDialog.vue?vue&type=script&lang=js&"
export * from "./OptionFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports